import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GoToStep1 } from '../../actions/app.js';
import { LoadHotelsForVariations } from '../../actions/hotels.js';
import { HotelListLoader } from '../../components/HotelListLoader';
import { translate } from '../../utils/wp.js';

import { HotelFilters } from './hotels/HotelFilters';
import { HotelList } from './hotels/HotelList';

export function HotelSelector() {
    const hasLoadedHotels = useSelector((state) => state.hotels.has_loaded_hotels);
    const isLoadingHotels = useSelector((state) => state.hotels.is_loading_hotels);
    const confirmedPackage = useSelector((state) => state.cart.confirmed_package);
    const foodTicket = useSelector((state) => state.food.food_ticket);
    const confirmedFood = useSelector((state) => state.food.confirmed_food);

    const dispatch = useDispatch();

    const hotelsAreOptional = NOJESRESOR_PRODUCT.hotels.optional;
    const noHotels = NOJESRESOR_PRODUCT.hotels.without;

    useEffect(() => {
        dispatch(LoadHotelsForVariations());
    }, []);

    if (
        !confirmedPackage ||
        (foodTicket && !confirmedFood) ||
        (hotelsAreOptional && !hasLoadedHotels && !isLoadingHotels) ||
        noHotels
    ) {
        return null;
    }

    return (
        <div className="step hotels">
            <div className="single-product__wrapper single-product__hotel-list">
                <div className="relative pb-4 md:pb-6 flex items-center justify-center">
                    <button
                        className="pl-2 pr-3 py-1.5 bg-black/[0.05] rounded-sm inline-flex items-center justify-center gap-1.5 text-sm font-semibold absolute left-0 hover:bg-black/10"
                        title="Back"
                        onClick={() => dispatch(GoToStep1())}
                    >
                        <i className="icon-arrow text-[16px]"></i>
                        <span className="hidden sm:block">{translate('back')}</span>
                    </button>
                    <span className="text-lg font-bold px-14 text-center">
                        {translate('choose_hotel_and_number_of_nights')}
                    </span>
                </div>

                {!hasLoadedHotels ? (
                    <HotelListLoader />
                ) : (
                    <div className="hotel-list">
                        <div className="box mb-2">
                            <HotelFilters />
                        </div>
                        <HotelList />
                    </div>
                )}
            </div>
        </div>
    );
}
